import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SupplierPaymentFormPage from "./SupplierPaymentFormPage";
import SupplierPaymentListPage from "./SupplierPaymentListPage";
import { SupplierPaymentProvider } from "../../store/supplierPaymentContext";
import { SupplierProvider } from "../../store/supplierContext";
import { CurrencyProvider } from "../../store/currencyContext";

const SupplierPaymentIndex: React.FC = () => (
    <SupplierProvider>
        <CurrencyProvider>
            <SupplierPaymentProvider>
                <Routes>
                    <Route path="form" element={<SupplierPaymentFormPage />} />
                    <Route path="form/:id" element={<SupplierPaymentFormPage />} />
                    <Route path="list" element={<SupplierPaymentListPage />} />
                    <Route index element={<Navigate to="list" replace />} />
                    <Route path="*" element={<Navigate to="list" />} />
                </Routes>
            </SupplierPaymentProvider>
        </CurrencyProvider>
    </SupplierProvider>
);

export default SupplierPaymentIndex;
